import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Payment, Bill } from '../../types';

interface PaymentsState {
  payments: Payment[];
  bills: Bill[];
  currentPayment: Payment | null;
  currentBill: Bill | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: PaymentsState = {
  payments: [],
  bills: [],
  currentPayment: null,
  currentBill: null,
  isLoading: false,
  error: null,
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setPayments: (state, action: PayloadAction<Payment[]>) => {
      state.payments = action.payload;
    },
    setBills: (state, action: PayloadAction<Bill[]>) => {
      state.bills = action.payload;
    },
    setCurrentPayment: (state, action: PayloadAction<Payment | null>) => {
      state.currentPayment = action.payload;
    },
    setCurrentBill: (state, action: PayloadAction<Bill | null>) => {
      state.currentBill = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setPayments, setBills, setCurrentPayment, setCurrentBill, setLoading, setError } = paymentsSlice.actions;
export default paymentsSlice.reducer;